<template>
  <div>
    <p>Use this form to temporarily view pages with a different license.</p>
    <h4>License Types: </h4>
    <ul class="list-unstyled">
      <li
        v-for="license in licenseChoices"
        :key="license.sub_type"
        class="radio">
        <label>
          <input
            type="radio"
            v-model="selectedLicense"
            :value="license">{{ license.type + ' ' + license.sub_type }}
        </label>
      </li>
    </ul>
    <h4>License End Date:</h4>
    <div class="btn-toolbar">
      <button class="btn btn-default date-select btn-xs" @click="adjustEndDate(false)">Make Expired</button>
      <button class="btn btn-default date-select btn-xs" @click="adjustEndDate(true)">Make Active</button>
    </div>
    <datepicker
      v-model="selectedEndDate"
      :clear-btn="false"
      icon-control-left="fa fa-arrow-left"
      icon-control-right="fa fa-arrow-right"/>
    <br>
    <br>
    <div class="btn-toolbar">
      <button
        class="btn btn-primary btn-confirm"
        :disabled="!isConfirmEnabled"
        @click="confirmSelection">Confirm</button>
      <button class="btn btn-default btn-cancel" @click="cancelSelection">Cancel</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'LicenseSelector',
  props: {
    userLicense: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      selectedLicense: {},
      selectedEndDate: moment()
        .add(10, 'days')
        .format(),
      licenseChoices: [
        {
          type: 'enterprise',
          sub_type: 'premium'
        },
        {
          type: 'individual',
          sub_type: 'trial'
        }
      ],
    }
  },
  computed: {
    isDirty() {
      if (!this.license) {
        return true
      }
      return !!this.license.type
    },
    isConfirmEnabled() {
      return (this.selectedLicense.type && this.isDirty) || false
    },
    futureDate() {
      return moment()
        .add(100, 'days')
        .format()
    },
    pastDate() {
      return moment()
        .subtract(10, 'days')
        .format()
    }
  },
  methods: {
    confirmSelection() {
      this.selectedLicense.end_date = this.selectedEndDate
      if (this.userLicense.start_date) {
        this.selectedLicense.start_date = this.userLicense.start_date
      } else {
        this.selectedLicense.start_date = moment()
          .subtract(100, 'days')
          .format()
      }
      this.selectedLicense.uuid = 'this is a uuid'
      this.$emit('select:confirmed', this.selectedLicense)
    },
    cancelSelection() {
      this.selectedLicense = this.userLicense
      this.$emit('select:canceled')
    },
    adjustEndDate(active) {
      if (active) {
        this.selectedEndDate = this.futureDate
      } else {
        this.selectedEndDate = this.pastDate
      }
    }
  },
  created() {
    this.selectedLicense = this.userLicense
  }
}
</script>

<style scoped lang="less">
ul {
  margin-bottom: 32px;
}
button.date-select {
  margin-bottom: 10px;
}
</style>
